type Props = {
  width?: number;
  height?: number;
  fill?: string;
  stroke?: string;
  className?: string;
};

export function SparkleIcon(props: Props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={props.width ?? 12}
      height={props.height ?? 14}
      viewBox="0 0 12 14"
      className={props.className}
    >
      <path
        d="M0.386013 6.9114C0.922339 6.87922 5.92993 6.65826 7.41047 0.970593C7.45563 0.797547 7.47962 0.724609 7.6497 0.724609C7.69557 0.724609 7.70898 0.731045 7.74426 0.749637C7.84094 0.801122 7.82118 0.894796 7.78801 1.02136C6.30747 6.70831 11.2254 6.98505 11.7872 6.98505C11.9361 6.99935 11.9692 7.08015 11.9692 7.08015C12.0165 7.17955 12.0073 7.19528 11.9551 7.29396C11.9093 7.36475 11.8662 7.40336 11.634 7.43769C11.0779 7.5192 6.09224 7.78664 4.61805 13.4493C4.57288 13.6223 4.48679 13.696 4.31672 13.6774C4.2158 13.6667 4.1283 13.6238 4.15793 13.4564C5.18613 7.66794 0.817191 7.39907 0.256166 7.39907C0.256166 7.39907 0.018348 7.39907 0 7.13021C0 7.13021 0.0134082 6.93356 0.386013 6.9114Z"
        fill={props.fill ?? '#FA685B'}
      />
    </svg>
  );
}
